import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class FollowupReasonsService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  createReason(_reason) {
    const url = `${environment.FOLLOWUP_BASE}/companies/${this.company_id}/followup/reason`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, _reason, { headers });
  }

  updateReason(_reason): Observable<any> {
    const url = `${environment.FOLLOWUP_BASE}/companies/${this.company_id}/followup/reason/${_reason.id}`;
    return this.http.put<any>(url, _reason);
  }
}
